import { useState, useContext, useEffect, useRef } from "react";
import Button from "./Button";
import Single from "./Single";
import Open from "./Open";
import Rating from "./Rating";
import Slide from "./Slider";
import { DataContext } from "../context/DataContext";
import { AnswersContext } from "../context/AnswersContext";
import { EmailTypeContext } from "../context/EmailTypeContext";
import { GlobalStylesContext } from "../context/GlobalStylesContext";
import doingCxRightBlack from "../assets/doing-cx-right-black.png";
import doingCxRightWhite from "../assets/doing-cx-right-white.png";
import onrEdgeBlack from "../assets/onr-edge-black.png";
import onrEdgeWhite from "../assets/onr-edge-white.png";
import clearStorage from "../utils/clearStorage";
import ErrorModal from "./ErrorModal";
import ThankYou from "./ThankYou";
import MasterWrapper from "./MasterWrapper";
import ProgressBar from "./ProgressBar";
import styled from "styled-components";
import MultipleLabel from "./MultipleLabel";
import MatrixLabel from "./MatrixLabel";
import RankLabel from "./RankLabel";
import PercentageLabel from "./PercentageLabel";
import Dropdown from "./Dropdown";
import MidPage from "./MidPage";
import SingleRank from "./SingleRank";
import MatrixMultiple from "./MatrixMultiple";
import Cleanser from "./Cleanser";

const SurveyContent = ({
  loaderRef,
  localizedText,
  chosenLanguage,
  fetchError,
  currentPage,
  setCurrentPage,
  currentQuestionIndex,
}) => {
  const {
    paginatedData,
    setFetchError,
    messageError,
    setMessageError,
    setAttention,
    defaultLanguage,
    thankYou,
    setThankYou,
    stateCleanser, 
    setStateCleanser
  } = useContext(DataContext);
  const {
    answeredQuestions,
    setAnsweredQuestions,
    currentPageAnswers,
    setCurrentPageAnswers,
  } = useContext(AnswersContext);
  const { emailTypeQuestions, numberTypeQuestions, floatingTypeQuestions } =
    useContext(EmailTypeContext);
  const { isDark } = useContext(GlobalStylesContext);
  const [errors, setErrors] = useState([]);
  const [otherErrors, setOtherErrors] = useState([]);
  const [slideDirection, setSlideDirection] = useState(null);
  const [isAnimating, setIsAnimating] = useState(false);

  // Track questions that should be hidden and clean up their answers
  const cleanupTimeoutRef = useRef(null);
  
  useEffect(() => {
    // Clear any pending cleanup
    if (cleanupTimeoutRef.current) {
      clearTimeout(cleanupTimeoutRef.current);
    }

    // Debounce the cleanup to avoid multiple rapid updates
    cleanupTimeoutRef.current = setTimeout(() => {
      const currentPageData = paginatedData?.[currentPage - 1];
      if (!currentPageData || currentPageAnswers.length === 0) return;

      const hiddenQuestionCodes = [];
      
      // Check each question on current page
      currentPageData.forEach(questionObj => {
        const shouldShow = showQuestion(questionObj.showIf, questionObj);
        if (!shouldShow && questionObj.Answers?.[0]?.AnswerCode) {
          hiddenQuestionCodes.push(questionObj.Answers[0].AnswerCode);
        }
      });

      // If there are hidden questions with answers, clean them up
      if (hiddenQuestionCodes.length > 0) {
        const filteredAnswers = currentPageAnswers.filter(ans => {
          const answerCode = typeof ans === 'string' ? ans.split('=')[0] : ans[0]?.split('=')[0];
          return !hiddenQuestionCodes.some(code => 
            answerCode === code || answerCode?.includes(code)
          );
        });
        
        // Only update if something changed
        if (filteredAnswers.length !== currentPageAnswers.length) {
           
          setCurrentPageAnswers(filteredAnswers);

          let answeredQuestionsCopy = [...answeredQuestions]
          answeredQuestionsCopy[currentPage - 1] = filteredAnswers
           
          setAnsweredQuestions(answeredQuestionsCopy);
          
        }
      }
    }, 100); // 100ms debounce

    return () => {
      if (cleanupTimeoutRef.current) {
        clearTimeout(cleanupTimeoutRef.current);
      }
    };
  }, [answeredQuestions, currentPage, paginatedData]);

  const showQuestion = (showIfLogic, questionObj) => { 
    let answer = true;
    if (showIfLogic) {
      let showIfLogicParsed = showIfLogic?.replace("<>", "!==")?.replace(/</g, "")?.replace(/>/g, "");

      let showIfLogicArray = showIfLogicParsed.split(/\|\||&&/).map(ans => ans.replace("((","").replace("))","").replace("(","").replace(")","").replace("<","").replace(">",""))                 

      showIfLogicArray.forEach(showIfLogicPiece => {
          if (!showIfLogicPiece.includes("!==")) {
            if (
              answeredQuestions.find((answerArray) => answerArray?.includes(showIfLogicPiece.replace(' ', '').replace('==','')))
            ) {
              showIfLogicParsed = showIfLogicParsed.replace(
                eval("/" + showIfLogicPiece.replace(' ', '') + "/g"),
                "true"
              );
            } else {
              showIfLogicParsed = showIfLogicParsed.replace(
                eval("/" + showIfLogicPiece.replace(' ', '') + "/g"),
                "false"
              );
            }
          } else {
            if (
              answeredQuestions.find((answerArray) => answerArray?.includes(showIfLogicPiece.replace(' ', '').replace('!=',''))
            )) {
              console.log(showIfLogicPiece.replace("!=","="));
              showIfLogicParsed = showIfLogicParsed.replace(
                eval("/" + showIfLogicPiece.replace(' ', '') + "/g"),
                "false"
              );
            } else {
              showIfLogicParsed = showIfLogicParsed.replace(
                eval("/" + showIfLogicPiece.replace(' ', '') + "/g"),
                "true"
              );
            }          
          }
      })


         
        if (questionObj?.QuestionType === "MatrixLabel" && questionObj) {
                       
          // let toShow = 
           
          
          answer = eval(showIfLogicParsed) && questionObj.Answers?.some((answerObj) => {
            return (answerObj?.showIf
              ? showQuestion(answerObj.showIf)
              : true);
          }) && parseDynamicQuestionText(questionObj.QuestionName, true) !== "undefined";

          // if (!toShow) {
          //          
          // }

          // return toShow
        } else if (questionObj) {
                       
          answer = eval(showIfLogicParsed) && questionObj.Answers?.some((answerObj) => {
            return (answerObj?.showIf
              ? showQuestion(answerObj.showIf)
              : true);
          });
        } else {
                                                       
                           
          answer = eval(showIfLogicParsed)
          // return true
        }
      
    } else if (questionObj && questionObj.QuestionType !== "DropDown") {                                  
      answer = questionObj.Answers?.some((answerObj) => {
        return (answerObj?.showIf
          ? showQuestion(answerObj.showIf)
          : true);
      });
    } else {
      answer = questionObj ? questionObj?.Answers?.some((answerObj) => {
        return (answerObj?.showIf
          ? showQuestion(answerObj.showIf)
          : true); 
      }) : true
    };

    // Q18: skip when user selected exactly one A17 option (any of A17_1..A17_7)
    if (questionObj?.QuestionCode === "q_18") {
      const a17Array = answeredQuestions.find(
        (arr) => arr && arr.some((s) => typeof s === "string" && s.startsWith("A17_"))
      );
      if (a17Array) {
        const selectedCount = a17Array.filter(
          (s) => typeof s === "string" && s.startsWith("A17_") && s.includes("=1")
        ).length;
        if (selectedCount === 1) {
          answer = false;
        }
      }
    }

    return answer
  }

  const parseDynamicQuestionText = (phrase, skipHtml = false) => {
    if (phrase) {
      let parsedText = phrase
      let matchedQuestionsArray = parsedText.match(/<Q(\d+)>/g)
      let answerExpressions = []
      let answerLabels = []
  
      if (matchedQuestionsArray) {
        matchedQuestionsArray.forEach((questionNumber) => {
                  
          let toPush = answeredQuestions.filter(ansArray => ansArray).find(ansArray => ansArray.find(ans => typeof ans === 'string' && ans?.split('=')[0] === `A${questionNumber.split('<Q')[1].split('>')[0]}`)) || answeredQuestions.filter(ansArray => ansArray).find(ansArray => ansArray.find(ans => typeof ans === 'string' && ans?.split('=')[0].includes(`A${questionNumber.split('<Q')[1].split('>')[0]}_o`)))
          if (toPush) {
            if (toPush.some(ans => ans.split('=')[0] === `A${questionNumber.split('<Q')[1].split('>')[0]}_o`)) {
              answerExpressions.push(toPush.filter(ans => ans.includes('_o'))[0])
            } else {
              answerExpressions.push(toPush[0])
            }
          }
        })


               
  
        answerExpressions.forEach((answerExpression) => {
          //for 'Other' type questions
          if (answerExpression?.includes('_o') || answerExpression?.includes('o_')) {
            answerLabels.push(answerExpression.split('=')[1])
          } else {
            let answerNumber = answerExpression.match(/A(\d+)=/)[1]
            if (answerNumber) {
              answerLabels.push(paginatedData?.find(page => page[0].QuestionNo === Number.parseInt(answerNumber))[0].Answers.find(answer => answer.Expression === answerExpression)?.AnswerLabel)
            }
          }
        })
  
        matchedQuestionsArray.forEach((questionNumber, i) => {
          parsedText = parsedText.replace(new RegExp(questionNumber, 'g'), answerLabels[i])
        })
      }

  
      if (skipHtml) {
        return parsedText
      } else {
        return <span dangerouslySetInnerHTML={{ __html: parsedText }} />
      }
    } else {
      return null
    }
  }

  const validate = (nextPage) => {

    let errorsToAdd = [];
    let otherErrorsToAdd = [];
    let relevantPage;

         
    if (window.skip) {
      relevantPage = currentPage;
    } else {
      relevantPage = currentPage -1;
    }

    let localTranslations = localizedText?.find(
      (localText) => localText.ProjectId === Number.parseInt(chosenLanguage)
    );
              
    paginatedData[relevantPage]?.forEach((pageQuestion) => {
         
      let error;


      if (pageQuestion.QuestionType === "Rating") {
        if (pageQuestion.Answers.length === 5 && pageQuestion.Answers[0].AnswerLabel === 'Very Dissatisfied') {
          error = false; 
          let noneSelected = answeredQuestions[relevantPage].filter(answer => !answer.includes('=null')).length < window.shown
  
          if (noneSelected) {
            otherErrorsToAdd.push(`${localTranslations.AnswerAtLeast.replace(
              ">dyn<",
              pageQuestion.MinAnswer
            ).replace('.','')} per question.`)
          }
        } else {
          //debugger   
          error = false; 
          let noneSelected = (!answeredQuestions[relevantPage].filter(ans => typeof ans === 'string' && ans.split('=')[0].includes(pageQuestion.Answers[0].AnswerCode) && !(ans.includes('null') || ans.includes('NaN'))).length || !window.sliderMoved)

          if (noneSelected) {
            otherErrorsToAdd.push(`${localTranslations.AnswerAtLeast.replace(
              ">dyn<",
              pageQuestion.MinAnswer
            ).replace('.','')} in the slider.`)
          }
        }
      } else if (pageQuestion.QuestionType === "Slider") {
                        
        error = false;
        let noneSelected = answeredQuestions[relevantPage][0].some(ans => pageQuestion.Answers.filter(ans => ans.AnswerType === "None").map(ansObj => ansObj.Expression).includes(ans)) 
        let answeredQuestionsLength = answeredQuestions[relevantPage][0].filter(ans => !ans.includes('=0')).length

        if (!noneSelected) {
          if (window.shown !== 0 && window.shown < pageQuestion.MinAnswer) {
            if (answeredQuestionsLength < window.shown) {
              error = true;
                
              otherErrorsToAdd.push(localTranslations.AnswerAtLeast.replace(
              ">dyn<",
              pageQuestion.MinAnswer
            ))
            }
          } else {
            if (answeredQuestionsLength < pageQuestion.MinAnswer) {
              error = true;
                
              otherErrorsToAdd.push(localTranslations.AnswerAtLeast.replace(
              ">dyn<",
              pageQuestion.MinAnswer
            ))
            }
          }
  
          if (pageQuestion.MaxAnswer > 0 && (answeredQuestionsLength > pageQuestion.MaxAnswer)) {
             
            error = true; 
              
            otherErrorsToAdd.push(localTranslations.AnswerAtMost.replace(
              ">dyn<",
              pageQuestion.MaxAnswer
            ))
          }
        } else {
          error = false;
        }

      } else if (pageQuestion.QuestionType === "MatrixMultiple") {
        // if (answeredQuestions[relevantPage].length > pageQuestion.MaxAnswer) {
        //   otherErrorsToAdd.push(localTranslations.AnswerAtMost.replace(
        //     ">dyn<",
        //     pageQuestion.MaxAnswer
        //   ))
        // } else if (answeredQuestions[relevantPage].length < pageQuestion.MaxAnswer) {
        //   otherErrorsToAdd.push(localTranslations.AnswerAtLeast.replace(
        //     ">dyn<",
        //     pageQuestion.MinAnswer
        //   ))
        // }
                           
        let nonselectedQuestionCodes = [];
                              
        if (
          (pageQuestion.MinAnswer === 1 &&
            (!pageQuestion.showIf || showQuestion(pageQuestion.showIf))) ||
            answeredQuestions[relevantPage]?.filter(ansObj => ansObj.some(ans => ans.includes('=1'))).length < pageQuestion.MinAnswer 
        ) {          
          if (window.shown < pageQuestion.MinAnswer) {
            if (answeredQuestions[relevantPage]?.filter(ansObj => ansObj.some(ans => ans.includes('=1'))).length < window.shown || (!answeredQuestions[relevantPage])) {
              pageQuestion.Answers.forEach((answer) => {
                if (
                  answeredQuestions[relevantPage]?.find((answerArray) =>
                    answerArray.some(ans => ans.includes(answer.AnswerCode) && answerArray.some(ans => ans.includes('=1')))
                  )
                ) {
                  error = false;
                  return;
                } else {
                    if (!nonselectedQuestionCodes.includes(answer.Expression)) { 
                      nonselectedQuestionCodes.push(answer.Expression);
                    }
                }
              });
  
              error = true;
            }
          } else {
            if (answeredQuestions[relevantPage]?.filter(ansObj => ansObj.some(ans => ans.includes('=1'))).length < pageQuestion.MinAnswer || (!answeredQuestions[relevantPage])) {
              pageQuestion.Answers.forEach((answer) => {
                if (
                  answeredQuestions[relevantPage]?.find((answerArray) =>
                    answerArray.some(ans => ans.includes(answer.AnswerCode) && answerArray.some(ans => ans.includes('=1')))
                  )
                ) {
                  error = false;
                  return;
                } else {
                    if (!nonselectedQuestionCodes.includes(answer.Expression)) { 
                      nonselectedQuestionCodes.push(answer.Expression);
                    }
                }
              });
  
              error = true;
            }            
          }
        } else {
          pageQuestion.Answers.forEach((answer) => {
            if (
              answeredQuestions[relevantPage]?.find((answerArray) =>
                answerArray.some(ans => ans.includes(answer.AnswerCode) && answerArray.some(ans => ans.includes('=1')))
              )
            ) {
              error = false;
              return;
            } else {
                if (!nonselectedQuestionCodes.includes(answer.Expression)) { 
                  nonselectedQuestionCodes.push(answer.Expression);
                  error = true;
                }
            }
          });
        }

                 
        if (error) {
          errorsToAdd.push(...nonselectedQuestionCodes);
        }

      } else if (pageQuestion.QuestionType === "Single") {
        if (
          answeredQuestions[relevantPage]?.filter((ans) =>
            ans.includes(pageQuestion.Answers[0].AnswerCode.split('_')[0]) && !/=(null)?$/.test(ans)
          ).length === 0 || !answeredQuestions[relevantPage]
        ) {
          error = true;
            
          otherErrorsToAdd.push(localTranslations.ProvideAnswerMessage);
        }
          
        if (currentPageAnswers.some(ans => ans.includes('o')) && !currentPageAnswers.some(ans => ans.includes('o_')) && !currentPageAnswers.some(ans => ans.includes('o=null')) && !currentPageAnswers.some(ans => ans.includes('o=-998')) || (currentPageAnswers.find(ans => ans.includes('_o_'))?.match(/o_(\d+)=null/))) {
          error = true;
            
          otherErrorsToAdd.push(localTranslations.OtherNotSpecified);
        }

      } else if (pageQuestion.QuestionType === "SingleRank") {
        if (answeredQuestions[relevantPage]?.filter(
          (ans) => (ans && typeof ans === 'string' && ans?.split("=")[1] !== "" && ans?.split("=")[1] !== "null")
        ).filter(ans => !ans.includes('=-998')).length < (window.shown < pageQuestion.MinAnswer ? window.shown : pageQuestion.MinAnswer)) {
            
          otherErrorsToAdd.push(
            localTranslations.AnswerAtLeast.replace(
              ">dyn<",
              pageQuestion.MinAnswer
            )
          );
        } else if (pageQuestion.MaxAnswer > 0 && answeredQuestions[relevantPage]?.filter(
          (ans) => (ans && typeof ans === 'string' && ans?.split("=")[1] !== "" && ans?.split("=")[1] !== "null")
        ).filter(ans => !ans.includes('=-998')).length > (pageQuestion.MaxAnswer)) {
            
          otherErrorsToAdd.push(
            localTranslations.AnswerAtMost.replace(
              ">dyn<",
              pageQuestion.MaxAnswer
            )
          );
        } 
        if (
          answeredQuestions[relevantPage]?.filter((ans) =>
            ans.includes(pageQuestion.Answers[0].AnswerCode)
          ).length === 0
        ) {
          error = true;
            
          otherErrorsToAdd.push(localTranslations.ProvideAnswerMessage);
        }
      } else if (pageQuestion.QuestionType === "Open") {
        let openExpressionStub =
          pageQuestion.Answers[0].AnswerCode.split("_")[0];
        let openArrayIndex = answeredQuestions[relevantPage]?.findIndex(
          (answer) => typeof answer === "object"
        );
        let answeredQuestionsCopy = [...answeredQuestions];

        //debugger  

        if (openArrayIndex < 0) {
          //debugger  
          let newAnsweredQuestions = [
            ...answeredQuestionsCopy[relevantPage]?.filter(
              (ansExpression) => !ansExpression.includes(openExpressionStub)
            ),
            answeredQuestionsCopy[relevantPage]?.filter((ansExpression) =>
              ansExpression.includes(openExpressionStub)
            ),
          ];
          let newOpenArrayIndex = newAnsweredQuestions.findIndex(
            (answer) => typeof answer === "object"
          );
          if (newOpenArrayIndex >= 0) {
            //debugger  
            answeredQuestionsCopy[relevantPage] = newAnsweredQuestions;
            openArrayIndex = newOpenArrayIndex;
          }
        }
                                 
        if (
          !answeredQuestionsCopy[relevantPage] || (openArrayIndex >= 0 &&
          answeredQuestionsCopy[relevantPage][openArrayIndex]?.filter(
            (ans) => ans.split("=")[1] !== "" && ans !== "" && ans.split("=")[1] !== "-998" && ans.split("=")[1] !== "0"
          ).length < (window.shown < pageQuestion.MinAnswer ? window.shown : pageQuestion.MinAnswer))
        ) {
          //debugger  
          error = true;
             
          otherErrorsToAdd.push(localTranslations.ProvideAnswerMessage);
          // otherErrorsToAdd.push(`Please provide an answer to the question(s).`)
        } else if (openArrayIndex >= 0 && pageQuestion.MaxAnswer && pageQuestion.MaxAnswer > 0 &&
          answeredQuestionsCopy[relevantPage][openArrayIndex]?.filter(
            (ans) => ans.split("=")[1] !== "" && ans !== "" && ans.split("=")[1] !== "-998" && ans.split("=")[1] !== "0"
          ).length > pageQuestion.MaxAnswer) {
          //debugger   
          error = true;
            
          otherErrorsToAdd.push(
            localTranslations.AnswerAtMost.replace(
              ">dyn<",
              pageQuestion.MaxAnswer
            )
          );
        }
      } else if (pageQuestion.QuestionType === "DropDown") {                                  
        if (
          !answeredQuestions[relevantPage] || answeredQuestions[relevantPage]?.filter(answer => !answer.includes('=null') && !answer.includes('=-998'))?.length < pageQuestion.MinAnswer
        ) {
          if (window.shown < pageQuestion.MinAnswer) {
            if (answeredQuestions[relevantPage] || answeredQuestions[relevantPage]?.filter(answer => (!answer.includes('=null') && !answer.includes('=-998')))?.length < window.shown) {
              error = true;
                 
              otherErrorsToAdd.push(
                localTranslations.AnswerAtLeast.replace(
                  ">dyn<",
                  window.shown
                )
              );
            }
          } else {
            error = true;
              
            otherErrorsToAdd.push(
              localTranslations.AnswerAtLeast.replace(
                ">dyn<",
                pageQuestion.MinAnswer
              )
            );
          }
          // otherErrorsToAdd.push(`You must select at least ${pageQuestion.MinAnswer} response(s).`)
        } 
        else if ((pageQuestion.MaxAnswer && pageQuestion.MaxAnswer > 0) && answeredQuestions[relevantPage]?.length > pageQuestion.MaxAnswer) {
           
          error = true;
  
                    
          otherErrorsToAdd.push(
            localTranslations.AnswerAtMost.replace(
              ">dyn<",
              pageQuestion.MaxAnswer
            )
          );
        }
      } else if (pageQuestion.QuestionType === "Multiple") {
                                         
        if (
          !answeredQuestions[relevantPage] || answeredQuestions[relevantPage]?.filter(ans => ans && typeof ans === 'string' && !ans.includes('_o') && !/=(null)?$/.test(ans) && !/=(0)?$/.test(ans) && !ans.includes('=-998'))?.length < (window.shown < pageQuestion.MinAnswer ?window.shown : pageQuestion.MinAnswer) &&
          (!pageQuestion.showIf || showQuestion(pageQuestion.showIf))
        ) {
          error = true;
             
          otherErrorsToAdd.push(
            localTranslations.AnswerAtLeast.replace(
              ">dyn<",
              pageQuestion.MinAnswer
            )
          );
        } 
        else if ((pageQuestion.MaxAnswer && pageQuestion.MaxAnswer > 0) && answeredQuestions[relevantPage].filter(ans => ans && typeof ans === 'string' && !ans.includes('_o') && !/=(null)?$/.test(ans) && !/=(0)?$/.test(ans) && !ans.includes('=-998'))?.length > pageQuestion.MaxAnswer &&
          (!pageQuestion.showIf || showQuestion(pageQuestion.showIf))) {
           
          error = true;

                    
          otherErrorsToAdd.push(
            localTranslations.AnswerAtMost.replace(
              ">dyn<",
              pageQuestion.MaxAnswer
            )
          );
        }

              

        if ((currentPageAnswers?.includes(pageQuestion.Answers.find(ans => ans.AnswerType === "Other" || ans.AnswerType === "FloatingPoint" || ans.AnswerType === "Numeric" || ans.AnswerType === "Email")?.Expression) && !currentPageAnswers.find(ans => ans?.includes('_o'))) || (currentPageAnswers.some(ans => ans?.includes('_o')) && (currentPageAnswers.find(ans => ans?.includes('_o')).match(/=/g).length === 1 && (currentPageAnswers.find(ans => ans?.includes('_o'))[currentPageAnswers.find(ans => ans?.includes('_o')).length - 1] === "=" || currentPageAnswers.find(ans => ans?.includes('_o')).includes('=null') || currentPageAnswers.find(ans => ans?.includes('_o')).includes('=-998'))) && currentPageAnswers.find(ans => ans.includes(`${currentPageAnswers.find(ans => ans?.includes('_o')).split('_o')[0]}=`)).includes('=1'))) {
          error = true; 
            
          otherErrorsToAdd.push(localTranslations.OtherNotSpecified);
        }

      } else if (pageQuestion.QuestionType === "Rank") {
        let repeatingDigit = (array) => {
          const seen = new Set();
          for (const num of array) {
            if (seen.has(num)) {
              return num;
            }
            seen.add(num);
          }
          return null;
        };

        let rankedAnswers = answeredQuestions[relevantPage]
          .map((answers) => answers.split("=")[1])
          ?.filter((num) => parseInt(num) > 0);
        let repeatedDigit = repeatingDigit(
          answeredQuestions[relevantPage]?.map((num) =>
            Number.parseInt(num.split("=")[1])
          )
        );
        let otherCode = answeredQuestions[relevantPage]
          .find((answerCode) => answerCode.includes("_o"))
          .split("_o")[0];
        let otherCodeNumber = answeredQuestions[relevantPage]
          .find((answerCode) => answerCode.includes(`${otherCode}=`))
          .split("=")[1];
        let otherCodeText = answeredQuestions[relevantPage]
          .find((answerCode) => answerCode.includes(`${otherCode}_o`))
          .split("=")[1];

        const findNextMissing = () => {
          for (let i = 1; i <= pageQuestion.MinAnswer; i++) {
            if (!rankedAnswers.includes(`${i}`)) {
              return i;
            }
          }
        };
         
                      
        if (
          answeredQuestions[relevantPage]
            .find((answer) =>
              answer.includes(
                pageQuestion.Answers.find((obj) => obj.AnswerType === "None")
                  .AnswerCode
              )
            )
            .includes("=1")
        ) {
          //user chose the 'No preference' checkbox
          error = false;

          let answeredQuestionsCopy = [...answeredQuestions];

          answeredQuestionsCopy[relevantPage] = answeredQuestionsCopy[
            relevantPage
          ]?.filter((answerCode) => !answerCode.includes("_o="));
           
          setAnsweredQuestions(answeredQuestionsCopy);
           
          setCurrentPageAnswers(answeredQuestionsCopy[relevantPage]);
        } else if (repeatedDigit) {
          //repeated digits
          error = true;
             
          otherErrorsToAdd.push(
            localTranslations.RankMoreThanOnce.replace(
              "<rankdyn>",
              pageQuestion.MinAnswer
            ).replace(">dyn<", repeatedDigit)
          );

          return;
        } else if (
          !rankedAnswers.length ||
          rankedAnswers.length < pageQuestion.MinAnswer
        ) {
          //no choices ranked
          error = true;
              
          otherErrorsToAdd.push(
            localTranslations.RankMissing.replace(
              "<rankdyn>",
              pageQuestion.MinAnswer
            ).replace(">dyn<", `${findNextMissing()}`)
          );

          return;
        } else if (
          Number.parseInt(otherCodeNumber) > 0 &&
          (otherCodeText === "" || otherCodeText === "-998" || otherCodeText === "null")
        ) {
          //if the user has entered something in Other but has not filled in the description
          error = true;
             
          otherErrorsToAdd.push(
            localTranslations.RankMissingOther.replace(
              "<rankdyn>",
              pageQuestion.MinAnswer
            ).replace(">dyn<", otherCodeNumber)
          );

          return;
        } else if (
          Number.parseInt(otherCodeNumber) <= 0 &&
          (otherCodeText !== "" && otherCodeText !== "-998")
        ) {
          //if the user has filled in the description but has not entered something in Other
          error = true;
             
          otherErrorsToAdd.push(
            localTranslations.RankOther.replace(
              "<rankdyn>",
              pageQuestion.MinAnswer
            ).replace(">dyn<", otherCodeText)
          );

          return;
        } 
        else if ((pageQuestion.MaxAnswer && pageQuestion.MaxAnswer > 0) && rankedAnswers.length > pageQuestion.MaxAnswer) {
           
          error = true;
                                   
          otherErrorsToAdd.push(
            localTranslations.RankMaxValue.replace(
              ">dyn<",
              pageQuestion.MaxAnswer
            )
          );
        } 
        else {
          //no error, clean up
         
          if (otherCodeText === "" || otherCodeText === "-998" || otherCodeText === "null") {
            let answeredQuestionsCopy = [...answeredQuestions];
           
            answeredQuestionsCopy[relevantPage] = answeredQuestionsCopy[
              relevantPage
            ]?.filter((answerCode) => !answerCode.includes("_o="));
           
            setAnsweredQuestions(answeredQuestionsCopy);
             
            setCurrentPageAnswers(answeredQuestionsCopy[relevantPage]);
          }
        }
      } else if (pageQuestion.QuestionType === "Percentage") {
                                      
         

        let percentageTotal = answeredQuestions[relevantPage].filter(ans => !ans.includes(pageQuestion.Answers[pageQuestion.Answers.findIndex(answerObj => answerObj.AnswerType === 'Stay')].AnswerCode) && !ans.includes('-998') && !ans.includes('_o')).map(val => Number.parseInt(val.split('=')[1])).reduce((acc, value) => acc + value, 0)
        // Number.parseInt(
        //   answeredQuestions[relevantPage].filter(ans => !ans.includes(pageQuestion.Answers[pageQuestion.Answers.findIndex(answerObj => answerObj.AnswerType === 'Stay')].AnswerCode))
        //     .find((answerCode) =>
        //       answerCode?.includes(
        //         pageQuestion.Answers[pageQuestion.Answers.length - 1].AnswerCode
        //       )
        //     )
        //     ?.split("=")[1] === "null" || 
        //     answeredQuestions[relevantPage]
        //     .find((answerCode) =>
        //       answerCode?.includes(
        //         pageQuestion.Answers[pageQuestion.Answers.length - 1].AnswerCode
        //       )
        //     )
        //     ?.split("=")[1] === "-998" ? "0" : 
        //     answeredQuestions[relevantPage]
        //     .find((answerCode) =>
        //       answerCode?.includes(
        //         pageQuestion.Answers[pageQuestion.Answers.length - 1].AnswerCode
        //       )
        //     )
        //     ?.split("=")[1]
        // );

        let otherCode = answeredQuestions[relevantPage]
          .find((answerCode) => answerCode?.includes("_o"))
          ?.split("_o")[0];
        let otherCodePercentage = answeredQuestions[relevantPage]
          .find((answerCode) => answerCode?.includes(`${otherCode}=`))
          ?.split("=")[1] !== "-998" ? answeredQuestions[relevantPage]
          .find((answerCode) => answerCode?.includes(`${otherCode}=`))
          ?.split("=")[1] : "0";
        let otherCodeText = answeredQuestions[relevantPage]
          .find((answerCode) => answerCode?.includes(`${otherCode}_o`))
          ?.split("=")[1] !== '-998' ? answeredQuestions[relevantPage]
          .find((answerCode) => answerCode?.includes(`${otherCode}_o`))
          ?.split("=")[1] : "";
                

        otherCodePercentage = otherCodePercentage && !isNaN(otherCodePercentage) ? otherCodePercentage : 0

        percentageTotal = isNaN(percentageTotal) ? 0 : percentageTotal

                     
        if (percentageTotal < 100 || percentageTotal > 100) {
          //if percentage does not equal 100
          error = true;
             
          otherErrorsToAdd.push(
            localTranslations.PercentageTotal.replace(">dyn<", percentageTotal)
          );
          // otherErrorsToAdd.push('Total must add up to 100.');
          return;
        } 
        // else if ((window.shown !== 0 && window.shown < pageQuestion.MinAnswer) && answeredQuestionsLength < window.shown) {

        //     error = true;

        //     otherErrorsToAdd.push(localTranslations.AnswerAtLeast.replace(
        //     ">dyn<",
        //     pageQuestion.MinAnswer
        //   ))

        // } else if ((!window.shown || window.shown === 0 || (pageQuestion.MinAnswer <= window.shown)) && answeredQuestionsLength < pageQuestion.MinAnswer) {
        //     error = true;

        //     otherErrorsToAdd.push(localTranslations.AnswerAtLeast.replace(
        //     ">dyn<",
        //     pageQuestion.MinAnswer
        //   ))
        // } 
        else if (
          Number.parseInt(otherCodePercentage) > 0 &&
          (otherCodeText === "" || otherCodeText === "-998" || otherCodeText === "null")
        ) {
          //if the user has entered something in Other but has not filled in the description
          error = true;
             
          otherErrorsToAdd.push(
            localTranslations.OtherSpecifyNotAnswered.replace(
              ">dyn<",
              `${otherCodePercentage}%`
            )
          );
                       

          return;
        } else if (
          Number.parseInt(otherCodePercentage) <= 0 &&
          (otherCodeText && otherCodeText !== "" && otherCodeText !== "-998")
        ) {
          //if the user has filled in the description but has not entered something in Other
          error = true;
             
          otherErrorsToAdd.push(
            localTranslations.PercentageMissing.replace(">dyn1<", 0)
              .replace(">dyn2<", 100)
              .replace(">dyn<", otherCodeText)
          );
                       

          return;
        } 
        // else if (answeredQuestionsLength > pageQuestion.MaxAnswer) {
        //   error = true;

        //   otherErrorsToAdd.push(localTranslations.AnswerAtMost.replace(
        //   ">dyn<",
        //   pageQuestion.MaxAnswer
        // ))
        // } 
        else {
          //no error ... clean answer array
         
          if (otherCodeText === "" || otherCodeText === "-998" || otherCodeText === "null") {
            let answeredQuestionsCopy = [...answeredQuestions];
           
            answeredQuestionsCopy[relevantPage] = answeredQuestionsCopy[
              relevantPage
            ]?.filter((answerCode) => !answerCode.includes("_o="));
           
            setAnsweredQuestions(answeredQuestionsCopy);
             
            setCurrentPageAnswers(answeredQuestionsCopy[relevantPage]);
          } else {
            let answeredQuestionsCopy = [...answeredQuestions];

            answeredQuestionsCopy[relevantPage] = answeredQuestionsCopy[
              relevantPage
            ]?.filter((answerCode) => !(answerCode.includes(pageQuestion.Answers[pageQuestion.Answers.findIndex(ans => ans.AnswerLabel.includes('Total'))].AnswerCode) && answerCode.includes("=0")));
             
            setAnsweredQuestions(answeredQuestionsCopy);
             
            setCurrentPageAnswers(answeredQuestionsCopy[relevantPage]);
          }
        }
      } 
      //answered at least minimum number of questions per page
      else if (
        (pageQuestion.MinAnswer === paginatedData[relevantPage].length) && ((pageQuestion.MinAnswer === 1 &&
          (!pageQuestion.showIf || showQuestion(pageQuestion.showIf))) ||
        (answeredQuestions[relevantPage]?.filter(
          (ans) => (ans && typeof ans === 'string' && ans?.split("=")[1] !== "" && ans?.split("=")[1] !== "null")
        ).filter(ans => !ans.includes('=-998')).length  < pageQuestion.MinAnswer || (!answeredQuestions[relevantPage] && pageQuestion.QuestionType !== "MidPage" && pageQuestion.QuestionType !== "MatrixMultiple")))
      ) {

         

        let nonselectedQuestionCodes = [];
        if (window.shown < pageQuestion.MinAnswer && pageQuestion.QuestionType !== "Slider") {
          if (answeredQuestions[relevantPage]?.filter(
            (ans) => ans && ans.split("=")[1] !== "" && ans.split('=')[1] !== "null"
          ).length < window.shown || (!answeredQuestions[relevantPage])) {
            pageQuestion.Answers.forEach((answer) => {
              if (
                answeredQuestions[relevantPage]?.find((answerCode) =>
                  answerCode?.includes(answer.Expression)
                )
              ) {
                error = false;
                return;
              } else {
                if (pageQuestion.QuestionType === "MatrixLabel" ||
                  pageQuestion.QuestionType === "MatrixRange" ||
                  pageQuestion.QuestionType === "SingleRank") {
                    
                  if (!nonselectedQuestionCodes.includes(answer.Expression)) {
                   //   
                    nonselectedQuestionCodes.push(answer.Expression);
                  }
                } else {
                  if (
                    !nonselectedQuestionCodes.includes(pageQuestion.QuestionCode)
                  ) {
                   //   
                    nonselectedQuestionCodes.push(pageQuestion.QuestionCode);
                  }
                }
              }
            });

             

            error = true;
          }
        } else {    
          pageQuestion.Answers.forEach((answer) => {
            if (
              answeredQuestions[relevantPage]?.find((answerCode) =>
                answerCode?.includes(answer.Expression)
              )
            ) {
              error = false;
              return;
            } else {
              if (pageQuestion.QuestionType === "MatrixLabel" ||
                pageQuestion.QuestionType === "MatrixRange" ||
                pageQuestion.QuestionType === "SingleRank") {
                if (!nonselectedQuestionCodes.includes(answer.Expression)) {
                 //   
                  nonselectedQuestionCodes.push(answer.Expression);
                }
              } else {
                   
                if (
                  !nonselectedQuestionCodes.includes(pageQuestion.QuestionCode)
                ) {
                 //   
                  nonselectedQuestionCodes.push(pageQuestion.QuestionCode);
                }
              }
            }
          });
          error = true;
        }
        
        if (error) { 
          errorsToAdd.push(...nonselectedQuestionCodes);
        }
      } else if (answeredQuestions[relevantPage]?.filter(
        (ans) => (ans && typeof ans === 'string' && ans?.split("=")[1] !== "" && ans?.split("=")[1] !== "null")
      ).filter(ans => !ans.includes('=-998')).length  < pageQuestion.MinAnswer || (!answeredQuestions[relevantPage] && pageQuestion.QuestionType !== "MidPage" && pageQuestion.QuestionType !== "MatrixMultiple")) {
          
        otherErrorsToAdd.push(
          localTranslations.AnswerAtLeast.replace(
            ">dyn<",
            pageQuestion.MinAnswer
          )
        );
      } else if ((pageQuestion.MaxAnswer && pageQuestion.MaxAnswer > 0) && answeredQuestions[relevantPage]?.filter(
        (ans) => (ans && typeof ans === 'string' && ans?.split("=")[1] !== "" && ans?.split("=")[1] !== "null")
      ).filter(ans => !ans.includes('=-998')).length  > pageQuestion.MaxAnswer || (!answeredQuestions[relevantPage] && pageQuestion.QuestionType !== "MidPage" && pageQuestion.QuestionType !== "MatrixMultiple")) {
           
        otherErrorsToAdd.push(
          localTranslations.AnswerAtMost.replace(
            ">dyn<",
            pageQuestion.MaxAnswer
          )
        );
      } else if (pageQuestion.QuestionType === "Rank" && !!((pageQuestion.MaxAnswer && pageQuestion.MaxAnswer > 0) && answeredQuestions[relevantPage]?.filter(
        (ans) => ans && typeof ans === 'string' && ans?.split("=")[1] !== ""
      ).length > pageQuestion.MaxAnswer)) {
         
        error = true;
                          
        otherErrorsToAdd.push(
          localTranslations.RankMaxValue.replace(
            ">dyn<",
            pageQuestion.MaxAnswer
          )
        );
      }
    });
   //   

    //if email address is entered, validate email
    Object.keys(emailTypeQuestions).forEach((emailExpression) => {
      if (
        answeredQuestions[relevantPage]
          ?.filter((answer) => typeof answer === "string")
          .some((answeredQuestion) =>
            answeredQuestion.startsWith(emailExpression)
          )
      ) {
        let emailQuestionCode = emailTypeQuestions[emailExpression];
        //VALIDATE EMAIL
        //if false, set errorsToAdd
        const email = answeredQuestions[relevantPage]?.find((q) =>
          q.startsWith(emailExpression)
        );
        if (email) {
          const emailValue = email.split("=")[1];
          const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
          if (!emailRegex.test(emailValue)) {
            errorsToAdd.push(emailQuestionCode);
          } else {
            errorsToAdd = errorsToAdd?.filter(
              (questionCode) => questionCode !== emailQuestionCode
            );
          }
        }
      }
    });

     
    //if number type is entered, validate number
    Object.keys(numberTypeQuestions).forEach((numberExpression) => {
       
      if (
        answeredQuestions[relevantPage]
          ?.filter((answer) => typeof answer === "string")
          .some((answeredQuestion) =>
            answeredQuestion.startsWith(numberExpression)
          )
      ) {
         
        let numberQuestionCode = numberTypeQuestions[numberExpression];
        //VALIDATE NUMBER
        //if false, set errorsToAdd
        const number = answeredQuestions[relevantPage]?.find((q) =>
          q.startsWith(numberExpression)
        );
        if (number) {
          const numberValue = number.split("=")[1];
          if (
            typeof Number.parseInt(numberValue) !== "number" ||
            `${Number.parseInt(numberValue)}` === "NaN"
          ) {
               
            otherErrorsToAdd.push(localTranslations.MustBeInteger);
            setOtherErrors(otherErrorsToAdd);
          } else {
            let answeredQuestionsCopy = [...answeredQuestions]
            answeredQuestionsCopy[relevantPage] = answeredQuestionsCopy[relevantPage].map(ans => ans.includes('o') ? `${ans.split('o_')[0]}o=${ans.split('=')[1]}` : ans)
             
            setAnsweredQuestions(answeredQuestionsCopy);
            setOtherErrors([]);
          }
        }
      }
    });

    //if float type is entered, validate float
    Object.keys(floatingTypeQuestions).forEach((floatExpression) => {
      if (
        answeredQuestions[relevantPage]
          ?.filter((answer) => typeof answer === "string")
          .some((answeredQuestion) =>
            answeredQuestion.startsWith(floatExpression)
          )
      ) {
        let floatQuestionCode = floatingTypeQuestions[floatExpression];
        //VALIDATE FLOAT
        //if false, set errorsToAdd
        const float = answeredQuestions[relevantPage]?.find((q) =>
          q.startsWith(floatExpression)
        );
        if (float) {
          const floatValue = float.split("=")[1];
          if (
            typeof Number.parseFloat(floatValue) !== "number" ||
            `${Number.parseFloat(floatValue)}` === "NaN" ||
            !`${Number.parseFloat(floatValue)}`.includes(".")
          ) {
               
            otherErrorsToAdd.push(localTranslations.MustBeDecimalValue);
            setOtherErrors(otherErrorsToAdd);
          } else {
            setOtherErrors([]);
          }
        }
      }
    });

                                                                       

    if (errorsToAdd.length === 0 && otherErrorsToAdd.length === 0) {
      setErrors([]);
      setOtherErrors([]);
      
      loaderRef.current.complete();
      
      handleNextWithAnimation(() => {
        let mostUpdatedAnswers = checkPageChange(
          window.skip ? currentPage : relevantPage,
          setCurrentPage,
          answeredQuestions,
          paginatedData,
          "next"
        );

        let openArrayIndex = currentPageAnswers.findIndex(
          (answer) => typeof answer === "object"
        );

        let cleanedCurrentPageAnswers = currentPageAnswers;
                       

      if (openArrayIndex >= 0) {
        cleanedCurrentPageAnswers = [
          ...currentPageAnswers?.filter((ans) => typeof ans !== "object"),
          ...currentPageAnswers[openArrayIndex]?.filter((ans) =>
            ans?.includes("=") 
          ) || [],
        ];
      }

                        

      
      //if the page is a Single question type, check if there is an 'Open' type question and if so, if they have NOT chosen it, replace that answer code with null
     
      if (typeof cleanedCurrentPageAnswers === 'object' && paginatedData[currentPage-1].some(question => question.QuestionType === "Single") && paginatedData[currentPage-1][0].Answers.some(obj => (obj.AnswerType === "Email" ||
        obj.AnswerType === "Other" ||
        obj.AnswerType === "Numeric" ||
        obj.AnswerType === "FloatingPoint"))) {
        if (cleanedCurrentPageAnswers.length === 1 && !cleanedCurrentPageAnswers.find(ans => ans.includes("_o_"))) {
          cleanedCurrentPageAnswers.push(`${mostUpdatedAnswers[relevantPage][0].split('=')[0]}_o=null`)
        }
      }

      let allAnsweredQuestions = [];

     

      mostUpdatedAnswers.slice(0, mostUpdatedAnswers.length -1).forEach((ans) => {
        if (typeof ans === "object") {
          if (ans.length === 1) {
            typeof ans[0] !== "object"
              ? allAnsweredQuestions.push(ans[0])
              : ans[0].forEach((ansNested) => allAnsweredQuestions.push(ansNested));
          } else if (ans.length > 1) {
            ans.forEach((answer) =>
              answer ? 
              typeof answer !== "object"
                ? allAnsweredQuestions.push(answer)
                : answer.forEach((ansNested) =>
                    allAnsweredQuestions.push(ansNested)
                  )
                :
                null
            );
          }
        } else {
          allAnsweredQuestions.push(ans) 
        }
      })

       
     
        
      allAnsweredQuestions = allAnsweredQuestions.filter(ans => ans).filter((ans, i) => i > 0 ? ans?.split('=')[0] !== allAnsweredQuestions[i-1]?.split('=')[0] : true)
      let oQuestions = []

      allAnsweredQuestions.forEach(ans => {
        if (ans.includes('_o_') && ans.includes('=null')) {
          oQuestions.push(`${ans.split('_o')[0]}=null`)
        } 
      }) 

      let currentUrl = window.location.href;

      if (!sessionStorage.pid || sessionStorage.pid === "0") {
        sessionStorage.setItem('pid', `${currentUrl.includes('pid') ? window.location.href.split("pid=")[1].split("&")[0] : currentUrl.includes('dl') ? window.location.href.split("dl=")[1].split("&")[0] : -998}`)
      }
      
    // debugger     

    //TODO: for any shown but unanswered questions, need to put null, right now works with Open

   

    // for (let i = 0; i < currentPage; i++) {
    //   if (!!paginatedData[i].find(ansObj => ansObj.QuestionType === 'Open') && (!paginatedData[i].find(ansObj => ansObj.QuestionType === 'Open')?.showIf || showQuestion(paginatedData[i].find(ansObj => ansObj.QuestionType === 'Open')?.showIf, paginatedData[i].find(ansObj => ansObj.QuestionType === 'Open')))) {
    //     cleanedCurrentPageAnswers = cleanedCurrentPageAnswers.filter(ans => ans.split('=')[0] !== paginatedData[i].find(ansObj => ansObj.QuestionType === 'Open').Answers[0].AnswerCode)
    //     cleanedCurrentPageAnswers.push(`${paginatedData[i].find(ansObj => ansObj.QuestionType === 'Open').Answers[0].AnswerCode}=null`) 
    //     console.log(cleanedCurrentPageAnswers) 
    //   }
    // }

    for (let i = 0; i < currentPage; i++) {
      if (!!paginatedData[i].find(ansObj => ansObj.QuestionType === 'Open') && (!paginatedData[i].find(ansObj => ansObj.QuestionType === 'Open')?.showIf || showQuestion(paginatedData[i].find(ansObj => ansObj.QuestionType === 'Open')?.showIf, paginatedData[i].find(ansObj => ansObj.QuestionType === 'Open')))) {
        if (i + 1 === currentPage) {
          // if ((allAnsweredQuestions.filter(ans => !!(ans.split('=')[0] !== paginatedData[i].find(ansObj => ansObj.QuestionType === 'Open').Answers[0].AnswerCode && (ans.split('=')[1] === 'null' || ans.split('=')[1] === '-998'))).length)) {
          //   allAnsweredQuestions = allAnsweredQuestions.filter(ans => !(ans.split('=')[0] !== paginatedData[i].find(ansObj => ansObj.QuestionType === 'Open').Answers[0].AnswerCode && (ans.split('=')[1] === 'null' || ans.split('=')[1] === '-998')))
          // }

          if (allAnsweredQuestions.filter(ans => !!(ans.split('=')[0].includes(paginatedData[i].find(ansObj => ansObj.QuestionType === 'Open').Answers[0].AnswerCode) && (ans.split('=')[1] === 'null' || ans.split('=')[1] === '-998'))).length) {
 
            allAnsweredQuestions = allAnsweredQuestions.filter(ans => !((ans.split('=')[0].includes(paginatedData[i].find(ansObj => ansObj.QuestionType === 'Open').Answers[0].AnswerCode) && (ans.split('=')[1] === 'null' || ans.split('=')[1] === '-998'))))

            // allAnsweredQuestions.filter(ans => !(ans.split('=')[0].includes(paginatedData[i].find(ansObj => ansObj.QuestionType === 'Open').Answers[0].AnswerCode))) 
          }

          let currentPageAnswersFlattened = currentPageAnswers.map(ans => typeof ans === 'object' ? ans[0] : ans)
          if (currentPageAnswersFlattened.indexOf(currentPageAnswersFlattened.find(ans => typeof ans === 'undefined')) !== -1) {
            currentPageAnswersFlattened[currentPageAnswersFlattened.indexOf(currentPageAnswersFlattened.find(ans => typeof ans === 'undefined'))] = `${paginatedData[i].find(ansObj => ansObj.QuestionType === 'Open').Answers[0].AnswerCode}=-998`
          }
          //debugger
          if (currentPageAnswersFlattened.filter(ans => (!!(ans?.split('=')[0].includes(paginatedData[i].find(ansObj => ansObj.QuestionType === 'Open').Answers[0].AnswerCode) && (ans?.split('=')[1] === 'null' || ans?.split('=')[1] === '-998')))).length) {
            //debugger
            cleanedCurrentPageAnswers = cleanedCurrentPageAnswers.filter(ans => !(ans.split('=')[0].includes(paginatedData[i].find(ansObj => ansObj.QuestionType === 'Open').Answers[0].AnswerCode) && (ans.split('=')[1] === 'null' || ans.split('=')[1] === '-998')))

            cleanedCurrentPageAnswers.push(`${paginatedData[i].find(ansObj => ansObj.QuestionType === 'Open').Answers[0].AnswerCode}=null`) 
          }
        } else {
            //debugger
            if (allAnsweredQuestions.filter(ans => !!(ans.split('=')[0].includes(paginatedData[i].find(ansObj => ansObj.QuestionType === 'Open').Answers[0].AnswerCode) && (ans.split('=')[1] === 'null' || ans.split('=')[1] === '-998'))).length) {
 
              allAnsweredQuestions = allAnsweredQuestions.filter(ans => !((ans.split('=')[0].includes(paginatedData[i].find(ansObj => ansObj.QuestionType === 'Open').Answers[0].AnswerCode) && (ans.split('=')[1] === 'null' || ans.split('=')[1] === '-998'))))

              // allAnsweredQuestions.filter(ans => !(ans.split('=')[0].includes(paginatedData[i].find(ansObj => ansObj.QuestionType === 'Open').Answers[0].AnswerCode)))
            }
            if (!allAnsweredQuestions.find(ans => ans.split('=')[0] === paginatedData[i].find(ansObj => ansObj.QuestionType === 'Open').Answers[0].AnswerCode)) {
              allAnsweredQuestions.push(`${paginatedData[i].find(ansObj => ansObj.QuestionType === 'Open').Answers[0].AnswerCode}=null`) 
            }
        }
      }
    }


   //debugger
                                        
    fetch(`https://surveyapp.onrcx.net/${window.location.href.split(/sid=/)[1].split('&')[0]}/api/SaveAnswers`, {
      // fetch(`http://test.onrcx.com/${window.location.href.split(/sid=/)[1].split('&')[0]}/api/SaveAnswers`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ProjectCode: sessionStorage.sid,
          ProjectId: sessionStorage.pid,
          Answers: 
          [...Array.from(new Set([...allAnsweredQuestions, ...(typeof cleanedCurrentPageAnswers === 'object' && paginatedData[currentPage-1].some(question => question.QuestionType === "Single") && !cleanedCurrentPageAnswers.find(ans => ans.includes("null") && ans.includes("_o="))) ? 
          [...cleanedCurrentPageAnswers?.filter(
            (answerCode) => !/_o=$/.test(answerCode)).map(ans => ans.includes('o') ? `${ans.split('o_')[0]}o=${ans.split('=')[1]}` : ans).filter(ans => ans?.match(/=/g).length === 1), cleanedCurrentPageAnswers.find(ans => ans.includes('_o_'))?.match(/o_(\d+)=/)[1] ? `${paginatedData[relevantPage][0].Answers[0].AnswerCode}=${cleanedCurrentPageAnswers.find(ans => ans.includes('_o_'))?.match(/o_(\d+)=/)[1]}` : null].filter(ans => ans) :
          cleanedCurrentPageAnswers?.filter(
            (answerCode) => !/_o=$/.test(answerCode))])).map(ans => ans.includes('_o_') && ans.includes('=null') ? `${ans.split('_o')[0]}_o=null` : ans).filter(ans => !(ans.includes('_o_'))), ...oQuestions].sort((a, b) => {
              return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
            })
          ,
          Page: currentPage,
          UserScreen: `${
            window.innerWidth > 0 ? window.innerWidth : window.screen.width
          }x${
            window.innerHeight > 0 ? window.innerHeight : window.screen.height
          }`,
          Version: sessionStorage.getItem("vid"),
          UserId: `${sessionStorage.getItem("uid")}`,
          UserAgent: `${navigator.userAgent}`,
          TabId: `${sessionStorage.getItem("tid")?.replace("Z", "")}`,
          QueryParams: `${new URLSearchParams(window.location.search).toString()}` 
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          window.sliderMoved = false;
          if (data.ThankYou) {
            if (data?.Redirect && data.Redirect !== "null") {
              window.location.href = data.Redirect;
            } else {
              setThankYou(data.ThankYou)
            }
          } else if (data.Error) {
              
            setMessageError(
              data.Error.replace(/< br \/>/g, " ")
                .replace(/<br \/>/g, " ")
                .replace(/<br\/>/g, " ")
            );
            setAttention(data?.Attention);
            clearStorage();
          } else if (data) {
             
            console.log("Successful save");
          } else {
            console.log("error");
            loaderRef.current.complete();
          }
        })
        .catch((err) => {
          setFetchError(true);
          loaderRef.current.complete();
        });
      }); // End handleNextWithAnimation callback

    } else {
      window.errorPopped = false;
      if (otherErrorsToAdd.length) {
        setOtherErrors(otherErrorsToAdd);
      }
      if (errorsToAdd.length) {
        setErrors(errorsToAdd);
      }
    }
  };

  const renderPage = (pageQuestions, thankYou) => {
    if (thankYou) {          
    // if (thankYou || (currentPage > paginatedData.length) && !messageError) {
      return (
        <ThankYou
          chosenLanguage={chosenLanguage ? chosenLanguage : defaultLanguage}
          localizedText={localizedText}
          serverMessage={thankYou}
          parseDynamicQuestionText={parseDynamicQuestionText}
        />
      );
    } else if (!messageError) {
      window.shown = 0;
          
      return pageQuestions?.filter(questionObj => showQuestion(questionObj.showIf, questionObj)).filter(questionObj => questionObj?.QuestionName ? (parseDynamicQuestionText(questionObj.QuestionName, true) && parseDynamicQuestionText(questionObj.QuestionName, true) !== "undefined") : questionObj?.QuestionHead ? (parseDynamicQuestionText(questionObj.QuestionHead, true) && parseDynamicQuestionText(questionObj.QuestionHead, true) !== "undefined") : true ).map((question, i) => {
        if (question.QuestionType === "MatrixLabel" ||
          question.QuestionType === "MatrixRange" ||
          question.QuestionType === "SingleRank" || 
          question.QuestionType === "DropDown" ||
          question.QuestionType === "MatrixMultiple") {
          window.shown ? window.shown++ : window.shown = 1;
        }
        if (stateCleanser) {
           
          return <Cleanser />
        } else if (question.QuestionType === "MidPage") {
           
          return <MidPage 
            currentPage={currentPage} 
            parseDynamicQuestionText={parseDynamicQuestionText} 
            question={question} 
            currentPageAnswers={currentPageAnswers} 
            answeredQuestions={answeredQuestions} 
            setCurrentPageAnswers={setCurrentPageAnswers}
            setAnsweredQuestions={setAnsweredQuestions} 
          />;
        } else if (question.QuestionType === "DropDown") {
          return (
            <Dropdown
              questionsLength={pageQuestions?.length}
              pageQuestions={pageQuestions}
              question={question}
              showQuestion={showQuestion}
              index={i}
              currentPage={window.skip ? currentPage + 1 : currentPage}
              setCurrentPage={setCurrentPage}
              key={i}
              errors={errors}
              error={errors.includes(question.QuestionCode)}
              setErrors={setErrors}
              toDisplay={!question.showIf || showQuestion(question.showIf)}
              answeredQuestions={answeredQuestions}
              setAnsweredQuestions={setAnsweredQuestions}
              currentPageAnswers={currentPageAnswers}
              setCurrentPageAnswers={setCurrentPageAnswers}
              parseDynamicQuestionText={parseDynamicQuestionText}
            />
          );
        } else if (question.QuestionType === "Percentage") {
          return (
            <PercentageLabel
              questionsLength={pageQuestions?.length}
              pageQuestions={pageQuestions}
              question={question}
              index={i}
              currentPage={window.skip ? currentPage + 1 : currentPage}
              key={i}
              errors={errors}
              error={errors.includes(question.QuestionCode)}
              setErrors={setErrors}
              toDisplay={!question.showIf || showQuestion(question.showIf)}
              answeredQuestions={answeredQuestions}
              setAnsweredQuestions={setAnsweredQuestions}
              currentPageAnswers={currentPageAnswers}
              setCurrentPageAnswers={setCurrentPageAnswers}
              parseDynamicQuestionText={parseDynamicQuestionText}
            />
          );
        } else if (question.QuestionType === "Rank") {
          return (
            <RankLabel
              questionsLength={pageQuestions?.length}
              pageQuestions={pageQuestions}
              question={question}
              index={i}
              currentPage={window.skip ? currentPage + 1 : currentPage}
              key={i}
              errors={errors}
              error={errors.includes(question.QuestionCode)}
              setErrors={setErrors}
              toDisplay={!question.showIf || showQuestion(question.showIf)}
              answeredQuestions={answeredQuestions}
              setAnsweredQuestions={setAnsweredQuestions}
              currentPageAnswers={currentPageAnswers}
              setCurrentPageAnswers={setCurrentPageAnswers}
              parseDynamicQuestionText={parseDynamicQuestionText}
            />
          );
        } else if (question.QuestionType === "Multiple") {
          return (
            <MultipleLabel
              questionsLength={pageQuestions?.length}
              pageQuestions={pageQuestions}
              question={question}
              index={i}
              currentPage={window.skip ? currentPage + 1 : currentPage}
              key={i}
              errors={errors}
              error={errors.includes(question.QuestionCode)}
              setErrors={setErrors}
              toDisplay={!question.showIf || showQuestion(question.showIf)}
              answeredQuestions={answeredQuestions}
              setAnsweredQuestions={setAnsweredQuestions}
              currentPageAnswers={currentPageAnswers}
              setCurrentPageAnswers={setCurrentPageAnswers}
              parseDynamicQuestionText={parseDynamicQuestionText}
              showQuestion={showQuestion}
            />
          );
        } else if (
          question.QuestionType === "MatrixMultiple"
        ) {
           
          return (
            <MatrixMultiple
              questionsLength={pageQuestions?.length}
              pageQuestions={pageQuestions}
              question={question}
              index={i}
              currentPage={window.skip ? currentPage + 1 : currentPage}
              key={i}
              errors={errors}
              error={errors.includes(question.QuestionCode)}
              setErrors={setErrors}
              toDisplay={!question.showIf || showQuestion(question.showIf)}
              answeredQuestions={answeredQuestions}
              setAnsweredQuestions={setAnsweredQuestions}
              currentPageAnswers={currentPageAnswers}
              setCurrentPageAnswers={setCurrentPageAnswers}
              setOtherErrors={setOtherErrors}
              parseDynamicQuestionText={parseDynamicQuestionText}
            />
          );
        } else if (
          question.QuestionType === "MatrixLabel" ||
          question.QuestionType === "MatrixRange" ||
          question.QuestionType === "SingleRank" 
        ) {
                           
          return (
            <MatrixLabel
              questionsLength={pageQuestions?.length}
              pageQuestions={pageQuestions}
              question={question}
              index={i}
              currentPage={window.skip ? (currentPage + 1) : currentPage}
              key={i}
              errors={errors}
              error={errors.includes(question.QuestionCode)}
              setErrors={setErrors}
              toDisplay={!question.showIf || showQuestion(question.showIf)}
              answeredQuestions={answeredQuestions}
              setAnsweredQuestions={setAnsweredQuestions}
              currentPageAnswers={currentPageAnswers}
              setCurrentPageAnswers={setCurrentPageAnswers}
              setOtherErrors={setOtherErrors}
              parseDynamicQuestionText={parseDynamicQuestionText}
            />
          );
        } else if (question.QuestionType === "Single") {
                     
          return (
            <Single
              currentPage={window.skip ? currentPage + 1 : currentPage}
              key={i}
              errors={errors}
              error={errors.includes(question.QuestionCode)}
              setErrors={setErrors}
              toDisplay={!question.showIf || showQuestion(question.showIf)}
              showQuestion={showQuestion}
              question={question}
              answeredQuestions={answeredQuestions}
              setAnsweredQuestions={setAnsweredQuestions}
              currentPageAnswers={currentPageAnswers}
              setCurrentPageAnswers={setCurrentPageAnswers}
              setOtherErrors={setOtherErrors}
              parseDynamicQuestionText={parseDynamicQuestionText}
              questionsOnPage={pageQuestions?.filter(questionObj => showQuestion(questionObj.showIf, questionObj)).length || 0}
              shouldAutoAdvance={pageQuestions?.filter(questionObj => showQuestion(questionObj.showIf, questionObj)).length === 1}
              onAutoAdvance={() => {
                setOtherErrors([]);
                setErrors([]);
                validate(currentPage + 1);
              }}
            />
          );
        } else if (question.QuestionType === "Open") {
          return (
            <Open
              currentPage={window.skip ? currentPage + 1 : currentPage}
              key={i}
              errors={errors}
              error={errors.includes(question.QuestionCode)}
              setErrors={setErrors}
              toDisplay={!question.showIf || showQuestion(question.showIf)}
              question={question}
              answeredQuestions={answeredQuestions}
              setAnsweredQuestions={setAnsweredQuestions}
              currentPageAnswers={currentPageAnswers}
              setCurrentPageAnswers={setCurrentPageAnswers}
              showQuestion={showQuestion}
              parseDynamicQuestionText={parseDynamicQuestionText}
            />
          );
        } else if (question.QuestionType === "Rank") {
          <SingleRank
            currentPage={window.skip ? currentPage + 1 : currentPage}
            key={i}
            errors={errors}
            error={errors.includes(question.QuestionCode)}
            setErrors={setErrors}
            toDisplay={!question.showIf || showQuestion(question.showIf)}
            question={question}
            answeredQuestions={answeredQuestions}
            setAnsweredQuestions={setAnsweredQuestions}
            currentPageAnswers={currentPageAnswers}
            setCurrentPageAnswers={setCurrentPageAnswers}
            parseDynamicQuestionText={parseDynamicQuestionText}
          />;
        } else if (question.QuestionType === "Slider") {
          return (
            <Slide
              currentPage={window.skip ? currentPage + 1 : currentPage}
              key={i}
              errors={errors}
              error={errors.includes(question.QuestionCode)}
              setErrors={setErrors}
              toDisplay={!question.showIf || showQuestion(question.showIf)}
              question={question}
              answeredQuestions={answeredQuestions}
              setAnsweredQuestions={setAnsweredQuestions}
              currentPageAnswers={currentPageAnswers}
              setCurrentPageAnswers={setCurrentPageAnswers}
              parseDynamicQuestionText={parseDynamicQuestionText}
            />
          );
        } else if (question.QuestionType === "Rating") {
          if (question.Answers.length === 5 && question.Answers[0].AnswerLabel === 'Very Dissatisfied') {
            return (
              <Rating 
                currentPage={window.skip ? currentPage + 1 : currentPage} 
                key={i} 
                errors={errors} 
                error={errors.includes(question.QuestionCode)} 
                setErrors={setErrors} 
                toDisplay={!question.showIf || showQuestion(question.showIf)} 
                question={question} 
                answeredQuestions={answeredQuestions} 
                setAnsweredQuestions={setAnsweredQuestions}  
                currentPageAnswers={currentPageAnswers} 
                setCurrentPageAnswers={setCurrentPageAnswers}  
                parseDynamicQuestionText={parseDynamicQuestionText}
              />
            )
          } else { 
            return (
              <SingleRank
                currentPage={window.skip ? currentPage + 1 : currentPage}
                key={i}
                errors={errors}
                error={errors.includes(question.QuestionCode)}
                setErrors={setErrors}
                toDisplay={!question.showIf || showQuestion(question.showIf)}
                question={question}
                answeredQuestions={answeredQuestions}
                setAnsweredQuestions={setAnsweredQuestions}
                currentPageAnswers={currentPageAnswers}
                setCurrentPageAnswers={setCurrentPageAnswers}
                parseDynamicQuestionText={parseDynamicQuestionText}
              />
            );
          }
        }
      });
    }
  };

  let localTranslations = localizedText?.find(
    (localText) => localText.ProjectId === Number.parseInt(chosenLanguage)
  );

  // Animation handler for forward navigation
  const handleNextWithAnimation = (callback) => {
    if (isAnimating) return;
    
    setIsAnimating(true);
    setSlideDirection('left'); // Slide out to left
    
    setTimeout(() => {
      callback(); // Execute the actual page change
      setSlideDirection('enter-left'); // New content slides in from right
      
      setTimeout(() => {
        setSlideDirection(null);
        setIsAnimating(false);
      }, 300);
    }, 300);
  };

  // Animation handler for backward navigation
  const handleBackWithAnimation = (callback) => {
    if (isAnimating) return;
    
    setIsAnimating(true);
    setSlideDirection('right'); // Slide out to right
    
    setTimeout(() => {
      callback(); // Execute the actual page change
      setSlideDirection('enter-right'); // New content slides in from left
      
      setTimeout(() => {
        setSlideDirection(null);
        setIsAnimating(false);
      }, 300);
    }, 300);
  };

  const checkPageChange = (
    currentPage,
    setCurrentPage,
    answeredQuestions,
    paginatedData,
    direction
  ) => {
    if (direction === "next") {
      window.direction = "next"
      let nextPage = currentPage + 1;
      window.skip = false;
      let answeredQuestionsCopy = [...answeredQuestions]
        
      setStateCleanser(true)  

      const checkNext = (pageToCheck) => {
        const nextPageQuestions = paginatedData[pageToCheck];
                                      
        if (
          nextPageQuestions?.every((questionObj) => {
              
            return !(showQuestion(questionObj.showIf, questionObj));
          })
        ) {
                             
           
            
          window.skip = true;         
          nextPage += 1;
          checkNext(pageToCheck + 1);
        }
      };

                 
      window.shown = 0;
                
      checkNext(currentPage + 1);

                 
      if (window.skip) {             
        setCurrentPage(nextPage);
      } else {             
        setCurrentPage(nextPage + 1);
      }

      if (window.skip) {
        if (!answeredQuestionsCopy[nextPage - 1]) {
          answeredQuestionsCopy.push([]);
        }
      } else {
        if (!answeredQuestionsCopy[nextPage]) {
          answeredQuestionsCopy.push([]);
        }
      }

      if (paginatedData[currentPage][0].QuestionType === 'MidPage') {
        answeredQuestionsCopy[currentPage] = [`A${paginatedData[currentPage][0].QuestionCode.split('_')[1]}=_`]
      }


      if (window.skip) {
         
        setCurrentPageAnswers(
          answeredQuestionsCopy[nextPage - 1] ? answeredQuestionsCopy[nextPage - 1] : []
        );
      } else {
         
        setCurrentPageAnswers(
          answeredQuestionsCopy[nextPage] ? answeredQuestionsCopy[nextPage] : []
        );
      }

        
      setAnsweredQuestions([...answeredQuestionsCopy]);
      return answeredQuestionsCopy
    } else {
      setStateCleanser(true)
      window.skip = false;
      window.direction = "back"
      
      let newAnsweredQuestions = [...answeredQuestions];
       
       
      let previousPage = currentPage - 2;

      
        
      newAnsweredQuestions[previousPage + 1] = newAnsweredQuestions[previousPage + 1]?.length ? newAnsweredQuestions[previousPage + 1].filter(question => typeof question === 'string').map(question => `${question.split('=')[0]}=null`) : []

      const checkPrev = (pageToCheck) => {
                           
        const previousPageQuestions = paginatedData[pageToCheck];

                 
        if (
          previousPageQuestions.every((questionObj) => {
            return !(showQuestion(questionObj.showIf, questionObj));
          })
        ) {

                                              
          previousPage -= 1;
           


             
          newAnsweredQuestions[previousPage + 1] = newAnsweredQuestions[previousPage + 1]?.length ? newAnsweredQuestions[previousPage + 1].filter(question => typeof question === 'string').map(question => `${question.split('=')[0]}=null`) : []
           
                           
          checkPrev(pageToCheck - 1);
        }
      };

      //   
      window.shown = 0;
               
      checkPrev(currentPage - 2);
      
              
                                      
      setCurrentPage(previousPage + 1);

       
       
      setCurrentPageAnswers(
        newAnsweredQuestions[previousPage] ? newAnsweredQuestions[previousPage] : []
      );

        
       
      setAnsweredQuestions(newAnsweredQuestions);
    }
    setTimeout(() => {
      window.errorPopped = false;
    },200)
  };

             
  return (
    <SurveyContainer>
      {!thankYou && !fetchError && !messageError && paginatedData?.length > 0 && (
        <ProgressSection>
          <ProgressBar 
            currentPage={currentPage} 
            totalPages={paginatedData.length}
            className="mb-0"
          />
        </ProgressSection>
      )}
      
      <ContentSection>
        {!fetchError && (
          <QuestionsContainer slideDirection={slideDirection}>
            {currentPage === 1 && !thankYou && !messageError && window.location.href.includes('sid=26JT011') && (
              <FirstPageLogos>
                <DoingCxRightLogo
                  src={isDark ? doingCxRightWhite : doingCxRightBlack}
                  alt="Doing CX Right"
                />
                <OnrLogo
                  src={isDark ? onrEdgeWhite : onrEdgeBlack}
                  alt="ONR Edge"
                />
              </FirstPageLogos>
            )}
            {renderPage(window.skip ? paginatedData[currentPage] : paginatedData[currentPage - 1], thankYou)}
          </QuestionsContainer>
        )}
        
        <MasterWrapper padding={"15 10px"}>
          <ErrorModal
            chosenLanguage={chosenLanguage}
            localizedText={localizedText}
            fetchError={fetchError}
            errors={errors}
            otherErrors={otherErrors}
          />
        </MasterWrapper>
      </ContentSection>
      
      {!fetchError && !messageError && !thankYou && (
        <NavigationSection>
          <ButtonContainer
            backButton={!(currentPage > paginatedData.length) && currentPage > 1}
          >
            {!(currentPage > paginatedData.length) && currentPage > 1 && (
              <NavButton
                variant="back"
                onClick={() => {
                  if (isAnimating) return;
                  
                  handleBackWithAnimation(() => {
                    let newPage = currentPage - 1;
                    setOtherErrors([]);
                    setErrors([]);

                    checkPageChange(
                      currentPage,
                      setCurrentPage,
                      answeredQuestions,
                      paginatedData,
                      "back"
                    );
                  });
                }}
              >
                {localTranslations ? localTranslations?.Back : "Back"}
              </NavButton>
            )}
            {!(currentPage > paginatedData.length) && (
              <NavButton
                variant="next"
                onClick={() => {
                  setOtherErrors([]);
                  setErrors([]);
                  validate(currentPage + 1);
                }}
              >
                {localTranslations ? localTranslations?.Next : "Next"}
              </NavButton>
            )}
          </ButtonContainer>
        </NavigationSection>
      )}
    </SurveyContainer>
  );
};

const SurveyContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding-top: 72px;
  background-color: ${props => props.theme.bgPrimary};
  transition: ${props => props.theme.transition};
`;

const ProgressSection = styled.div`
  flex-shrink: 0;
  border-bottom: 1px solid ${props => props.theme.borderPrimary};
  background-color: ${props => props.theme.bgPrimary};
  padding: 1rem 1.5rem;
  
  @media (max-width: 768px) {
    padding: 0.75rem 1rem;
  }
`;

const ContentSection = styled.div`
  flex: 1 1 auto;
  background-color: ${props => props.theme.bgPrimary};
  padding: 2rem 1.5rem;
  display: flex;
  flex-direction: column;
  min-height: 0;
  
  @media (max-width: 768px) {
    padding: 1.5rem 1rem;
  }
`;

const QuestionsContainer = styled.div`
  max-width: 768px;
  margin: 0 auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  flex: 0 1 auto;
  transition: transform 0.3s ease, opacity 0.3s ease;
  
  ${props => props.slideDirection === 'left' && `
    transform: translateX(-100%);
    opacity: 0;
  `}
  
  ${props => props.slideDirection === 'right' && `
    transform: translateX(100%);
    opacity: 0;
  `}
  
  ${props => props.slideDirection === 'enter-left' && `
    animation: slideInFromRight 0.3s ease forwards;
  `}
  
  ${props => props.slideDirection === 'enter-right' && `
    animation: slideInFromLeft 0.3s ease forwards;
  `}
  
  @keyframes slideInFromRight {
    from {
      transform: translateX(100%);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }
  
  @keyframes slideInFromLeft {
    from {
      transform: translateX(-100%);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }
`;

const FirstPageLogos = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 2rem;
  flex-wrap: wrap;
  width: 100%;

  @media (max-width: 576px) {
    flex-direction: column;
    gap: 0.5rem;
  }
`;

const DoingCxRightLogo = styled.img`
  max-height: 72px;
  height: auto;
  width: auto;
  object-fit: contain;

  @media (max-width: 576px) {
    max-height: 56px;
  }
`;

const OnrLogo = styled.img`
  max-height: 60px;
  height: auto;
  width: auto;
  object-fit: contain;

  @media (max-width: 576px) {
    max-height: 48px;
  }
`;

const NavigationSection = styled.div`
  flex-shrink: 0;
  border-top: 1px solid ${props => props.theme.borderPrimary};
  background-color: ${props => props.theme.bgPrimary};
  padding: 1rem 1.5rem;
  
  @media (max-width: 768px) {
    padding: 0.75rem 1rem;
  }
`;

const ButtonContainer = styled.div`
  max-width: 768px;
  margin: 0 auto;
  display: flex;
  justify-content: ${props => props.backButton ? 'space-between' : 'flex-end'};
  align-items: center;
  gap: 1rem;
`;

const NavButton = styled.button`
  padding: 0.625rem 1.5rem;
  border-radius: 0.5rem;
  font-size: 1rem;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: ${props => props.theme.transition};
  border: none;
  
  ${props => props.variant === 'back' ? `
    background-color: transparent;
    color: ${props.theme.textSecondary};
    
    &:hover {
      background-color: ${props.theme.bgSecondary};
    }
    
    &:disabled {
      opacity: 0.4;
      cursor: not-allowed;
    }
  ` : `
    background-color: ${props.theme.selectedBorder};
    color: white;
    
    &:hover {
      background-color: ${props.theme.accentPrimaryHover || props.theme.selectedBorder};
      filter: brightness(0.9);
    }
    
    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  `}
`;

export default SurveyContent;
